<h2 mat-dialog-title>{{ 'nav.dialog.logout.title' | translate }}</h2>

<div class="login-logout-btns">
    <button mat-button [mat-dialog-close]="true">{{ 'nav.dialog.logout.cancel' | translate }}</button>
    <button mat-button (click)="logoutRequest()" cdkFocusInitial class="login-logout">{{ 'nav.dialog.logout.signout' | translate }}</button>
</div>